export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '飞飞漫画网翻页流畅不卡顿，是怎么做到的？',
    a: '飞飞漫画网对漫画图片进行了极速加载的优化处理，采用按需预加载与分页缓存技术，浏览到哪一页就提前准备下一页，配合流畅的翻页动效，真正做到翻页不卡顿、阅读不等待，让你随时随地畅快看漫画。',
  },
  {
    q: '夜间模式护眼真的有用吗？',
    a: '有用的。飞飞漫画网提供专属的夜间模式，阅读时自动降低屏幕亮度、调整为低蓝光的深色背景，并优化文字与画面的对比度，减少光线刺激，长时间追更也更护眼舒适。你可以在页面右上角一键开启夜间模式。',
  },
  {
    q: '在飞飞漫画网看漫画需要付费或登录吗？',
    a: '不需要。飞飞漫画网绝大多数漫画都可以免费直接阅读，无需注册登录，打开即看。我们始终把阅读体验放在第一位，让你以最快速度进入喜欢的作品。',
  },
  {
    q: '支持手机和电脑上阅读吗？',
    a: '支持。飞飞漫画网采用响应式设计，无论在手机、平板还是电脑上打开，都能自动适配屏幕，获得极速加载、翻页流畅的阅读体验，随时随地都能畅快看漫画。',
  },
  {
    q: '漫画更新后，怎么第一时间知道？',
    a: '你可以订阅我们的更新通知，或在页面下方留下常用邮箱。每当热门作品更新，我们会第一时间推送提醒，让你不错过任何一话更新。',
  },
  {
    q: '阅读过程中遇到图片加载问题怎么办？',
    a: '遇到图片加载缓慢时，可以尝试刷新当前页或切换网络。飞飞漫画网已针对极速加载做了大量优化，绝大多数情况下都能保持翻页流畅；如果问题仍然存在，欢迎通过页面底部的联系方式反馈给我们。',
  },
];